import React, { useContext, useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import TODIS_FORM_GENERAL from "./form/NP/general";
import TODIS_FORM_INFRA from "./form/NP/infrastructure";
import TODIS_FORM_OPS from "./form/NP/operations";
import TODIS_FORM_TENT_COMP from "./form/NP/tent_compliance";
import TODIS_FORM_SAFTEY from "./form/NP/safety";
import TODIS_FORM_MAINT from "./form/NP/maintenace";
import TODIS_FORM_ENV from "./form/GENERAL/environment";
import TODIS_FORM_CLIMATE from "./form/NP/climate_resilience";
import { TODIS_FORM_DSC } from "../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsExclamationCircleFill } from "react-icons/bs";
import TODIS_FORM_OTHER_ROADS from "./form/NP/other";
import { loadModules } from 'esri-loader';

const TODIS_FORM_NP = ({ errors, touched, status, setFieldValue, values, flagForm }) => {

    const [key, setKey] = useState('DataCollection'); // Estado para controlar la pestaña activa
    const [statusITSComp, setStatusITSComp] = useState(false)
    const [statusTolling, setStatusTolling] = useState(true)
    const [statusRoad, setStatusRoad] = useState(true)
    const [statusTabDisabled, setStatusTabDisabled] = useState(true)

    useEffect(() => {
            try {
                const [Query, query] = loadModules(["esri/rest/support/Query", "esri/rest/query"]);
                console.log("Modules loaded", Query, query);
    
                let queryUrl = "https://todis.transport-community.org/server/rest/services/Transport_services_parameters/FeatureServer/17";
                console.log("Query URL:", queryUrl);
    
                let queryObject = new Query();
                queryObject.where = `npm_road_id=${values.npmRwId}`;
                queryObject.returnGeometry = false;
                queryObject.outFields = "*";
    
                const results = query.executeQueryJSON(queryUrl, queryObject);
    
                if(results.features.length > 0) {
                    setStatusTabDisabled(false); 
                }
            } catch (error) {
                console.log("Something went wrong", error);
            }

    })

    useEffect(() => {
        /* if(values.tenTCategory == "4"){// Core 
            if((values.roadsNpmInfraDTO.category == 6 || values.roadsNpmInfraDTO.category == 7) && (values.roadsNpmInfraDTO.pavementCondition == 9 || values.roadsNpmInfraDTO.pavementCondition == 10)){
                setFieldValue('roadsNpmTentcompDTO.tentReqComp', true)
                return
            }
        }else if(values.tenTCategory == "5"){// Comprehensive  
            if(values.roadsNpmInfraDTO.pavementCondition == 9 || values.roadsNpmInfraDTO.pavementCondition == 10){
                setFieldValue('roadsNpmTentcompDTO.tentReqComp', true)
                return
            }
        }
        setFieldValue('roadsNpmTentcompDTO.tentReqComp', false) */

    }, [values.tenTCategory, values.roadsNpmInfraDTO.category, values.roadsNpmInfraDTO.pavementCondition])

    useEffect(() => {
        if (values.roadsNpmInfraDTO.its == false) {
            setFieldValue('roadsNpmTentcompDTO.itsComp', "N/A")
            setStatusITSComp(true)
        } else {
            setStatusITSComp(false)
        }

    }, [values.roadsNpmInfraDTO.its])

    useEffect(() => {
        if (values.roadsNpmInfraDTO.tolled == "false") {
            setFieldValue('roadsNpmTentcompDTO.tollInterop', "")
            setStatusTolling(true)
        } else {
            setStatusTolling(false)
        }

    }, [values.roadsNpmInfraDTO.tolled])

    useEffect(() => {
        if ((values.roadsNpmInfraDTO.lengthTunnelsDirA + values.roadsNpmInfraDTO.lengthTunnelsDirB) == 0) {
            setFieldValue('roadsNpmTentcompDTO.roadTunnelComp', "")
            setStatusRoad(true)
        } else {
            setStatusRoad(false)
        }

    }, [values.roadsNpmInfraDTO.lengthTunnelsDirA, values.roadsNpmInfraDTO.lengthTunnelsDirB])

    const generalTooltip = (
        <Tooltip id="general-tooltip">
            General data
        </Tooltip>
    );

    const infraTooltip = (
        <Tooltip id="infra-tooltip">
            Infrastructure characteristics
        </Tooltip>
    );

    const tentTooltip = (
        <Tooltip id="tent-tooltip">
            Compliance with the relevant TEN-T standards
        </Tooltip>
    );

    const operationsTooltip = (
        <Tooltip id="operations-tooltip">
            Operations related data
        </Tooltip>
    );

    const safetyTooltip = (
        <Tooltip id="safety-tooltip">
            Safety related data
        </Tooltip>
    );

    const maintTooltip = (
        <Tooltip id="maint-tooltip">
            Maintenance related data
        </Tooltip>
    );

    const environmentTootltip = (
        <Tooltip id="environment-tooltip">
            Environment related data
        </Tooltip>
    );

    const climateTootltip = (
        <Tooltip id="climate-tooltip">
            Climate related data
        </Tooltip>
    );

    const otherTootltip = (
        <Tooltip id="other-tooltip">
            Other parameters related data
        </Tooltip>
    );

    return (
        <Tabs defaultActiveKey="General" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">
            <Tab eventKey="General" title={
                <OverlayTrigger placement="bottom" overlay={generalTooltip}>
                    <div>General</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_GENERAL errors={errors} touched={touched} disabled={status} TypeForm="" TetCategory="tenTCategory" setFieldValue={setFieldValue} values={values} flagForm={flagForm} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="remarks" label="Remarks" name="remarks" disabled={status} />
                            {errors.remarks && touched.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="section 3" title={
                <OverlayTrigger placement="bottom" overlay={infraTooltip}>
                    <div>Infrastructure</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_INFRA errors={errors} touched={touched} disabled={status} sectionData={values.roadsNpmInfraDTO} setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="TENT" title={
                <OverlayTrigger placement="bottom" overlay={tentTooltip}>
                    <div>TEN-T Compliance</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_TENT_COMP errors={errors} touched={touched} disabled={status} statusITSComp={statusITSComp} statusTolling={statusTolling} statusRoad={statusRoad} />
            </Tab>
            <Tab eventKey="Operations" title={
                <OverlayTrigger placement="bottom" overlay={operationsTooltip}>
                    <div>Operations</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_OPS errors={errors} touched={touched} disabled={status} sectionData={values.roadsNpmOpsDTO && values.roadsNpmInfraDTO} setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="Safety" title={
                <OverlayTrigger placement="bottom" overlay={safetyTooltip}>
                    <div>Safety</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_SAFTEY errors={errors} touched={touched} disabled={status} />
            </Tab>
            <Tab eventKey="Maintenance" title={
                <OverlayTrigger placement="bottom" overlay={maintTooltip}>
                    <div>Maintenance</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_MAINT errors={errors} touched={touched} disabled={status} />
            </Tab>
            <Tab eventKey="Environmental" title={
                <OverlayTrigger placement="bottom" overlay={environmentTootltip}>
                    <div>Environmental Impact</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_ENV errors={errors} touched={touched} disabled={status} TypeForm="roadsNpmEnvDTO" />
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Climate" title={
                <OverlayTrigger placement="bottom" overlay={climateTootltip}>
                    <div>Climate resilience</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_CLIMATE errors={errors} touched={touched} disabled={status} sectionData={values.roadsNpmClimateDTO} setFieldValue={setFieldValue} values={values} />
            </Tab>
            {statusTabDisabled ? null :
                <Tab eventKey="Other" title={
                    <OverlayTrigger placement="bottom" overlay={otherTootltip}>
                        <div>Others</div>
                    </OverlayTrigger>
                }
                >
                    <Container>
                        <Row>
                            <TODIS_FORM_OTHER_ROADS errors={errors} touched={touched} disabled={status} TypeForm="roadsNpmOtherDTO" values={values} />
                        </Row>
                    </Container>
                </Tab>
            }
        </Tabs>
    )
}

export default TODIS_FORM_NP;